/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP SystemError 화면 개발
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from 'react-router-dom';
/**
 * @brief EHP SystemError 화면 컴포넌트
 * @param -
 * @returns react components
 */
//
function SystemError() {
    const navigate = useNavigate();
    function onClickGoPage(url) {
        navigate(url);
        //
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container filereports" },
            React.createElement("div", { className: "area__error" },
                React.createElement("strong", null, "\uC11C\uBE44\uC2A4 \uC810\uAC80 \uC911 \uC785\uB2C8\uB2E4."),
                React.createElement("p", null, "\uC11C\uBE44\uC2A4\uB97C \uC77C\uC2DC \uC911\uB2E8 \uD558\uC624\uB2C8 \uC7A0\uC2DC \uD6C4 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694.")))));
}
export default SystemError;
